import styled from '@emotion/styled';
import { FC } from 'react';
import Text from 'components/base/Text';
import { border3 } from 'styles';
import { numberwithComma } from 'util/number';
import { CategoryFilterItem } from 'util/search_utils';

type CategoryItem = {
  id: string;
  name: string;
  multiple: boolean;
  properties: boolean;
  selected: boolean;
  count: number;
  sub_category_list: Array<{
    id: string;
    name: string;
    multiple: boolean;
    properties: boolean;
    selected: boolean;
    count: number;
  }>;
};

interface Props {
  category_list: CategoryItem[];
  onAddCategory: (category: CategoryFilterItem) => void;
}

/**
 * 검색필터 - 메인카테고리 리스트
 * @component
 */
const MainCategories: FC<Props> = ({ category_list, onAddCategory }) => {
  return (
    <SC.Container>
      {category_list.map((category, index) => {
        const handleCategoryClick = () => {
          onAddCategory({ id: category.id, name: category.name, depth: 1 });
        };

        const category_count = numberwithComma(category.count, { max_count: 9_999, max_count_subfix: '+' });
        return (
          <SC.Item key={index} onClick={handleCategoryClick}>
            <Text variant='title6_medium' color='gray_active'>
              {category.name}
            </Text>
            <Text variant='body4_regular' color='gray_tertiary' ml={4}>
              {category_count}
            </Text>
          </SC.Item>
        );
      })}
    </SC.Container>
  );
};

export default MainCategories;

const SC = {
  Container: styled.div`
    box-sizing: border-box;
    display: grid;
    grid-template-columns: repeat(2, 1fr);
    grid-gap: 9px 8px;
    width: 100%;
    min-width: 0px;
  `,
  Item: styled.div`
    border: 1px solid ${border3};
    border-radius: 4px;
    padding: 14px 16px;
    cursor: pointer;
  `,
};
